import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  commitImport,
  csvDryRun,
  fetchSheetCsv,
  listImports,
  slackSync,
} from "@/features/people/people.api";

export function useCsvDryRun(workspaceId: string) {
  return useMutation({
    mutationFn: (csvContent: string) => csvDryRun(workspaceId, csvContent),
  });
}

export function useCommitImport(workspaceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { importId: string; holdInviteEmails?: readonly string[] }) =>
      commitImport(workspaceId, input.importId, input.holdInviteEmails),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["imports", workspaceId] });
      qc.invalidateQueries({ queryKey: ["people", workspaceId] });
      qc.invalidateQueries({ queryKey: ["people-stats", workspaceId] });
      qc.invalidateQueries({ queryKey: ["departments", workspaceId] });
      qc.invalidateQueries({ queryKey: ["invitations", workspaceId] });
    },
  });
}

/** Fetch the published-CSV form of a Google Sheet for the mapping screen. */
export function useFetchSheetCsv(workspaceId: string) {
  return useMutation({
    mutationFn: (sheetsUrl: string) => fetchSheetCsv(workspaceId, sheetsUrl),
  });
}

export function useSlackSync(workspaceId: string) {
  return useMutation({
    mutationFn: () => slackSync(workspaceId),
  });
}

export function useImportsHistory(workspaceId: string) {
  return useQuery({
    queryKey: ["imports", workspaceId],
    queryFn: () => listImports(workspaceId),
    staleTime: 30_000,
  });
}
